import { createContext } from 'react';

export interface UnsavedChangesGuardOptions {
    id?: string;
    hasUnsavedChanges(): boolean;
    onKeep?(): void;
    onDiscard?(): void;
    onSave?(): Promise<unknown> | void;
    overlayContainer?(): HTMLElement | null | undefined;
}

/**
 * Used to enhance react-router's useBlocker functionality by enabling the use of multiple blockers
 */
export interface UnsavedChangesContextValue {
    register(id: string, options: UnsavedChangesGuardOptions): void;
    unregister(id: string): void;
    withUnsavedChangesGuard(options: WithUnsavedChangesGuardOptions): void;
}

export type UnsavedChangesResolution = 'discard' | 'keep' | 'save';

export interface WithUnsavedChangesGuardOptions {
    onProceed(): void;
    onResolve?(resolution: UnsavedChangesResolution): void;
}

export const UnsavedChangesContext = createContext<UnsavedChangesContextValue | undefined>(undefined);
